import React from 'react'
import styled from 'styled-components'

/**
 * boxテキスト
 */
const Text: React.FC<TextProps> = (props) => {
  return <StyledText {...props} />
}

export type TextProps = {
  children: React.ReactNode
  color?: string
  bold?: boolean
  decoration?: string
  fontSize?: string
  textAlign?:
    | 'start'
    | 'end'
    | 'left'
    | 'right'
    | 'center'
    | 'justify'
    | 'match-parent'
}

export const StyledText = styled.span<{
  color?: string
  bold?: boolean
  decoration?: string
  fontSize?: string
  textAlign?: string
}>`
  display: block;
  color: ${(props): string =>
    props.color ? props.color : 'var(--color-text)'};
  font-weight: ${(props): string => (props.bold ? 'bold' : 'normal')};
  font-size: ${(props): string => props.fontSize || '16px'};
  line-height: 1.4;
  white-space: pre-wrap;
  text-align: ${(props): string => props.textAlign || 'none'};
  text-decoration: ${(props): string => props.decoration || ' none '};
`

export default Text
